import React from 'react';
import Button from 'components/DesignSystem/Button';
import Dialog from 'components/DesignSystem/Dialog';
import useGroupLocationDeleteFeedback from 'hooks/Meteorology/Agro/useGroupLocationDeleteFeedback';

export default function GroupLocationDeleteFeedback() {
  const {
    successOpen,
    errorOpen,
    message,
    onCloseSuccess,
    onCloseError,
  } = useGroupLocationDeleteFeedback();

  return (
    <>
      <Dialog
        open={successOpen}
        dismiss={onCloseSuccess}
        type="success"
      >
        <Dialog.Body>
          {message}
        </Dialog.Body>
        <Dialog.Footer>
          <Button onClick={onCloseSuccess}>
            Ok
          </Button>
        </Dialog.Footer>
      </Dialog>
      <Dialog
        open={errorOpen}
        dismiss={onCloseError}
        type="error"
      >
        <Dialog.Body>
          {message}
        </Dialog.Body>
        <Dialog.Footer>
          <Button onClick={onCloseError}>
            Ok
          </Button>
        </Dialog.Footer>
      </Dialog>
    </>
  );
}
